module.exports = __webpack_public_path__ + "img/SL-M-200-270.300b9afe.svg";